export default __webpack_public_path__ + "static/DSC_0346-3eec638b6fbf0735ef27af9fd45a87e4.jpg";